// frontend/src/pages/teacher/StudentListPage.js (نسخه اصلاح شده)

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ useNavigate ایمپورت شد
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
// ✅ FaEye برای لینک به جزئیات استفاده می‌شود
import { FaPlus, FaEye, FaPen, FaUserSlash, FaSearch, FaSpinner } from 'react-icons/fa';
import '../../assets/styles/global.css';
import EnrollStudentModal from './EnrollStudentModal'; 

// (کامپوننت Avatar بدون تغییر)
const Avatar = ({ name }) => {
    const initial = name ? name.charAt(0) : '?';
    return <div className="avatar">{initial}</div>;
};

const StudentListPage = () => {
    const navigate = useNavigate(); // ✅ هوک navigate
    const [students, setStudents] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error, setError] = useState(null); 

    const fetchStudents = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${API_BASE_URL}/core/teacher/students/`, getAuthHeaders());
            
            const studentData = response.data.map(student => ({
                ...student,
                name: `${student.first_name || ''} ${student.last_name || ''}`.trim() || student.username,
                course_count: 0 
            }));

            setStudents(studentData);
        } catch (err) {
            console.error("خطا در دریافت دانش‌آموزان:", err);
            setError("خطا در بارگذاری لیست دانش‌آموزان. لطفا اتصال خود را بررسی کنید.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStudents();
    }, []);

    const handleStudentEnrolled = () => {
        fetchStudents(); 
    };

    const filteredStudents = students.filter(student =>
        student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        student.username.includes(searchTerm)
    );

    // ✅ (جدید) تابع برای هدایت به صفحه جزئیات دانش‌آموز
    const handleViewProgress = (studentId) => {
        navigate(`/teacher/student-progress/${studentId}`);
    };

    const renderTableBody = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan="5" className="text-center">
                        <FaSpinner className="spinner" style={{ fontSize: '2rem', margin: '20px' }} />
                        <p>در حال بارگذاری لیست دانش‌آموزان...</p>
                    </td>
                </tr>
            );
        }

        if (error) {
            return <tr><td colSpan="5" className="alert alert-danger text-center">{error}</td></tr>;
        }

        if (filteredStudents.length === 0) {
            return <tr><td colSpan="5" className="text-center">هیچ دانش‌آموزی در دوره‌های شما ثبت‌نام نکرده است.</td></tr>;
        }

        return filteredStudents.map(student => (
            <tr key={student.id}>
                <td>
                    {/* ✅✅✅ کلیک روی نام، شما را به صفحه جزئیات می‌برد */}
                    <div 
                        className="user-cell" 
                        onClick={() => handleViewProgress(student.id)} 
                        style={{ cursor: 'pointer', color: 'var(--accent-cyan)' }}
                    >
                        <Avatar name={student.name} />
                        <span>{student.name}</span>
                    </div>
                </td>
                <td>{student.username}</td>
                <td>—</td> 
                <td>{student.course_count || 0} دوره</td> 
                <td>
                    <div className="action-buttons">
                        {/* ✅✅✅ دکمه "مشاهده" نیز به صفحه جزئیات می‌رود */}
                        <button 
                            className="action-btn btn-view" 
                            title="مشاهده پروفایل و پیشرفت"
                            onClick={() => handleViewProgress(student.id)}
                        >
                            <FaEye />
                        </button>
                        <button className="action-btn btn-edit" title="ویرایش اطلاعات"><FaPen /></button>
                        <button className="action-btn btn-disable" title="حذف از دوره"><FaUserSlash /></button>
                    </div>
                </td>
            </tr>
        ));
    };

    return (
        <>
            <EnrollStudentModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onStudentEnrolled={handleStudentEnrolled}
            />

            <div className="page-container" style={{maxWidth: '1200px'}}>
                <div className="page-header">
                    <div>
                        <h1>مدیریت دانش‌آموزان</h1>
                        <p>لیست دانش‌آموزان ثبت‌نام شده در دوره‌های شما.</p>
                    </div>
                    <button 
                        className="button button-primary" 
                        onClick={() => setIsModalOpen(true)}
                    >
                        <FaPlus />
                        افزودن دانش‌آموز
                    </button>
                </div>

                <div className="data-table-container">
                    <div className="table-toolbar">
                        <div className="search-box">
                            <FaSearch className="search-icon" />
                            <input
                                type="text"
                                placeholder="جستجو بر اساس نام یا کد ملی..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>نام و نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>پایه و رشته</th>
                                <th>دوره‌ها</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderTableBody()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default StudentListPage;